
export const locale = {
    lang: 'en',
    data: {
        USER: 'USER',
        PASSAWORD : 'PASSAWORD',
        REMBEMBER : 'Remember Me',
        RECUPERAR : 'Forgot Password?',
        LOGIN : 'LOGIN',
        "MENSAJES": "The system closes in",
        "BUTTONVOLVER": "Cancel",
        "BUTTONCONFIRMAR": "Confirm",
        "MENSAJERECUPERA": "RECOVER YOUR PASSWORD",
        "DNI": "Identification document",
        "ENVIARPassword": "SEND",
        "VOLVERLOGIN": "LOGIN",
   }     
};  